import { render } from "./Roulette.vue?vue&type=template&id=2a2a5bac&scoped=true"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"

import "./Roulette.vue?vue&type=style&index=0&id=2a2a5bac&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2a5bac"]])

export default __exports__